export enum PlanStatusEnum {
    ACTIVE = "Active",
    BLOCKED = "Blocked"
}
